/* eslint-disable linebreak-style */
/* eslint-disable import/extensions */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/react-in-jsx-scope */
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Fade } from 'react-awesome-reveal';

import Header from '../parts/Header';
import Footer from '../parts/Footer';
import { useLanguage } from '../contexts/LanguageContext.js';
import blogData from '../json/blogData';
import blogDataEn from '../json/blogDataEn';

export default function BlogPage() {
  const { t, language } = useLanguage();
  
  // Select blog data based on current language
  const currentBlogData = language === 'en' ? blogDataEn : blogData;
  
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />

      <main className="min-h-screen">
        {/* Hero Section with Blog Grid */}
        <section className="relative overflow-hidden py-0">
          <div className="absolute inset-0" />
          <div className="relative container mx-auto px-4">
            <Fade direction="up" duration={1000}>
              <div className="text-center mb-16">
                <h1 className="text-4xl lg:text-6xl font-bold mb-6 text-white mt-20">
                  {t('blogTitle')}
                </h1>
                <p className="text-xl lg:text-2xl mb-8 max-w-3xl mx-auto text-white">
                  {t('blogSubtitle')}
                </p>
              </div>
            </Fade>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {currentBlogData.map((blog, index) => (
                <Fade key={blog.id} direction="up" duration={1000} delay={300 + index * 100}>
                  <article className="bg-white/80 backdrop-blur-sm rounded-xl shadow-lg overflow-hidden hover:shadow-xl hover:scale-105 transition-all duration-300">
                    <div className="relative overflow-hidden">
                      <img 
                        src={blog.image} 
                        alt={blog.title}
                        className="w-full h-48 object-cover transition-transform duration-300 hover:scale-110"
                      />
                      <div className="absolute top-4 left-4">
                        <span className="bg-green-600 text-white px-3 py-1 rounded-full text-sm font-semibold shadow-lg">
                          {blog.category}
                        </span>
                      </div>
                      <div className="absolute top-4 right-4">
                        <span className="bg-white/90 text-gray-700 px-2 py-1 rounded-full text-xs font-medium">
                          {blog.readTime}
                        </span>
                      </div>
                    </div>
                    
                    <div className="p-6">
                      <div className="flex items-center justify-between text-sm text-gray-500 mb-3">
                        <span className="font-medium">{blog.author}</span>
                        <span>
                          {new Date(blog.publishedDate).toLocaleDateString('id-ID', {
                            day: 'numeric',
                            month: 'short',
                            year: 'numeric',
                          })}
                        </span>
                      </div>
                      
                      <h3 className="text-xl font-bold text-gray-800 mb-3 hover:text-green-600 transition-colors line-clamp-2">
                        <Link 
                          to={`/blog/${blog.id}`}
                          onClick={() => {
                            window.scrollTo(0, 0);
                          }}
                        >
                          {blog.title}
                        </Link>
                      </h3>
                      
                      <p className="text-gray-600 mb-4 line-clamp-3">
                        {blog.excerpt}
                      </p>
                      
                      <div className="flex flex-wrap gap-2 mb-4">
                        {blog.tags.slice(0, 3).map((tag) => (
                          <span 
                            key={tag}
                            className="bg-gray-100/70 text-gray-600 px-2 py-1 rounded text-xs backdrop-blur-sm"
                          >
                            #{tag}
                          </span>
                        ))}
                      </div>
                      
                      <div className="flex items-center justify-between">
                        <Link 
                          to={`/blog/${blog.id}`}
                          className="bg-green-800 text-white px-4 py-2 rounded-lg font-semibold hover:bg-green-700 transition-colors shadow-md"
                          onClick={() => {
                            // Scroll to top immediately when link is clicked
                            window.scrollTo(0, 0);
                          }}
                        >
                          {t('readMore')} →
                        </Link>
                      </div>
                    </div>
                  </article>
                </Fade>
              ))}
            </div>

            {currentBlogData.length === 0 && (
              <Fade direction="up" duration={1000}>
                <div className="text-center py-12">
                  <div className="text-6xl mb-4">🔍</div>
                  <h3 className="text-2xl font-bold text-white mb-2">
                    Tidak Ada Produk
                  </h3>
                  <p className="text-white/90">
                    Belum ada produk tersedia
                  </p>
                </div>
              </Fade>
            )}
          </div>
        </section>

        {/* Call to Action Section */}
        <section className="py-0">
          <div className="container mx-auto px-4">
            <Fade direction="up" duration={1000}>
              <div className="rounded-2xl p-8 lg:p-12 text-black text-center shadow-2xl" style={{ backgroundColor: "rgba(249,250,251,0.8)" }}>
                <h2 className="text-3xl lg:text-4xl font-bold mb-4">
                  {t('needConsultation')}
                </h2>
                <p className="text-lg lg:text-xl mb-8 max-w-2xl mx-auto opacity-90">
                  {t('consultationDescription')}
                </p>
                
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                  <Link 
                    to="/discuss-project"
                    className="bg-white text-green-800 px-8 py-4 rounded-lg font-semibold hover:bg-green-800 hover:text-white transition-colors shadow-lg"
                  >
                    {t('contactUsButton')}
                  </Link>
                  <Link 
                    to="/project"
                    className="bg-green-800 text-white border-white px-8 py-4 rounded-lg font-semibold hover:bg-white hover:text-green-800 transition-colors"
                  >
                    {t('viewAllProducts')}
                  </Link>
                </div>
              </div>
            </Fade>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}
